webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(4)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(7),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_particles_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var processAnimation = function processAnimation(component) {
  if (!component.animation.ready) {
    var delay = -component.animation.delay;
    component.animation.order.forEach(function (selectors) {
      delay = delay + component.animation.delay;
      selectors.forEach(function (selector) {
        component.$el.querySelector(selector).style['animation-delay'] = delay / 1000 + 's';
      });
    });
  }
  component.animation.ready = true;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  data: function data() {
    return {
      animation: {
        order: [['.title'], ['.subtitle'], ['.social']],
        delay: 500,
        ready: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    particlesJS.load('particles-js', 'static/particles.json');

    setTimeout(function () {
      processAnimation(_this);
    }, this.animation.delay);
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "animated fadeIn",
    attrs: {
      "id": "particles-js"
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animation.ready),
      expression: "animation.ready"
    }],
    staticClass: "hero is-fullheight has-text-centered"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced is-size-2 animated fadeInLeft"
  }, [_vm._v("\n          Vladimir Avgustov\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-size-4 animated fadeInRight"
  }, [_vm._v("\n          Ruby on Rails | Full Stack Web Developer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "social is-size-2 animated fadeInLeft"
  }, [_c('a', {
    attrs: {
      "id": "github",
      "title": "GitHub",
      "href": "https://github.com/vavgustov",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "linkedin",
      "title": "LinkedIn",
      "href": "https://www.linkedin.com/in/vavgustov",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "email",
      "title": "Email",
      "href": "mailto:vavgustov@yandex.ru"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])])
}]}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.cdec42269c791bd4963e.js